<!-- ── Verificación de Cuenta ──────────────────────────────────────────── -->
<div class="tw-min-h-screen tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-12">
  <div class="tw-w-full tw-max-w-md">

    <!-- Card -->
    <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-200 tw-shadow-sm tw-overflow-hidden">

      <!-- Header -->
      <div class="tw-p-8 tw-pb-6 tw-text-center" style="background:linear-gradient(160deg,#0f172a 0%,#1e3a5f 50%,#1d4ed8 100%);">
        <div class="tw-mx-auto tw-w-14 tw-h-14 tw-rounded-2xl tw-bg-white/10 tw-flex tw-items-center tw-justify-center tw-mb-5">
          <svg class="tw-w-7 tw-h-7 tw-text-blue-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>
        <h1 class="tw-text-2xl tw-font-extrabold tw-text-white tw-mb-2">Verificación de Cuenta</h1>
        <p class="tw-text-blue-200 tw-text-sm tw-leading-relaxed">Ingresa el código de verificación que enviamos a tu correo electrónico.</p>
      </div>

      <!-- Form -->
      <div class="tw-p-8">
        <form [formGroup]="formVer" (ngSubmit)="verificarCuenta()">

          <!-- Código -->
          <div class="tw-mb-6">
            <label for="token" class="tw-block tw-text-sm tw-font-semibold tw-text-slate-700 tw-mb-2">Código de verificación</label>
            <input id="token" type="text" formControlName="token"
                   placeholder="Ingresa tu código"
                   class="tw-w-full tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-800 tw-outline-none tw-transition focus:tw-border-blue-400 focus:tw-ring-2 focus:tw-ring-blue-100"
                   autocomplete="one-time-code">
            <div class="tw-mt-2 tw-text-xs tw-text-red-500" *ngIf="formVer.controls.token.errors &&
                (formVer.controls.token.dirty || formVer.controls.token.touched)">
              <span *ngIf="formVer.controls.token.errors.required">El código es requerido.</span>
            </div>
          </div>

          <!-- Submit -->
          <button type="submit" [disabled]="!formVer.valid"
                  class="tw-w-full tw-py-3 tw-px-6 tw-rounded-xl tw-font-semibold tw-text-sm tw-text-white tw-transition tw-border-0 tw-cursor-pointer"
                  style="background:linear-gradient(135deg,#1d4ed8,#2563eb);"
                  [style.opacity]="!formVer.valid ? '0.5' : '1'"
                  [style.cursor]="!formVer.valid ? 'not-allowed' : 'pointer'">
            Confirmar cuenta
          </button>

          <!-- Success / Error messages -->
          <div class="tw-mt-5">
            <div *ngIf="envioCorreo && mensajeExito"
                 class="tw-p-3 tw-rounded-xl tw-bg-green-50 tw-border tw-border-green-200 tw-text-sm tw-text-green-700 tw-text-center">
              {{ mensajeExito }}
            </div>
            <div *ngIf="envioCorreo && mensajeError"
                 class="tw-p-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-text-center">
              {{ mensajeError }}
            </div>
            <div *ngIf="mensajeUsuarioNull"
                 class="tw-p-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-text-center">
              {{ mensajeUsuarioNull }}
            </div>
          </div>
        </form>

        <!-- Enlace para reenviar código -->
        <div class="tw-mt-6 tw-text-center">
          <p class="tw-text-sm tw-text-slate-500">
            ¿No recibiste el código?
            <a routerLink="/verificar/token" class="tw-font-semibold tw-text-blue-600 hover:tw-text-blue-800 tw-transition tw-cursor-pointer" style="text-decoration:none;">
              Reenviar código
            </a>
          </p>
        </div>
      </div>

    </div>
  </div>
</div>
